module.exports = __webpack_public_path__ + "img/zd-up-1.511802bb.svg";